export const SEATS_VERSIONS_FEATURE_FLAG = 'SEATS_VERSIONS_FEATURE_FLAG';
export const SLASHING_PRICES_FLAG = 'SLASHING_PRICES_FLAG';